import $ from 'jquery';
export class SubRegionSelect {
    static CountriesSubRegions = {"US":{"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","DC":"District of Columbia","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming"}}
	/*element;
	selectElement;
	inputElement;*/
	constructor (element) {
		this.element = element;
		this.inputElement = element.find('input');
		this.selectElement = $('<select name="' + this.inputElement.prop('name') + '"></select>');
		this.selectElement.attr('autocomplete', this.inputElement.attr('autocomplete'));
	}
	
	setCountry (countryCode) {
		if (SubRegionSelect.CountriesSubRegions[countryCode]) {
            // check if the input is in the DOM. If it is - replace it with the select
            if (this.inputElement.parent().length) {
                this.inputElement.replaceWith(this.selectElement);
            }
			this.selectElement.html('');
			// an empty first option, so the first region is never submitted by default
			this.selectElement.append($('<option value="" disabled>Select…</option>'));
			var selectByVal = false;
			let previousValue = this.inputElement.val();
			for(let code in SubRegionSelect.CountriesSubRegions[countryCode]) {
				let name = SubRegionSelect.CountriesSubRegions[countryCode][code];
				this.selectElement.append($('<option value="' + code + '">' + name + '</option>'));
				if (code == previousValue) {
					selectByVal = true; 
				}
			}
			if (selectByVal) {
				this.selectElement.val(previousValue);
			} else {
				this.selectElement.val('');
				this.selectElement[0].selectedIndex = 0;
			}
		} else {
            // check if the select is in the DOM. If it is - replace it with the input
            if (this.selectElement.parent().length) {
                this.selectElement.replaceWith(this.inputElement);
            }
            //this.inputElement.val('');
		}
	}
}